export default __webpack_public_path__ + "f65171738ca8c5dc4292b0c387f064e9.svg";